/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { UserTeamViewModel } from './UserTeamViewModel'; 

export function getUserTeamsOptions(onSuccess?: (result: UserTeamViewModel[]) => void) {
	return queryOptions({
		queryKey: ['user-teams'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/users/queries/getuserteams/';
			const resp = await axios.get<UserTeamViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}